import { twMerge } from 'tailwind-merge';

import Icon from '../icon/icon';

/* eslint-disable-next-line */

export type SpinnerColors = 'default' | 'primary' | 'secondary' | 'variant' | 'gray';
export interface SpinnerProps {
    size: number;
    className?: string;
    color?: SpinnerColors;
}

export function Spinner(props: SpinnerProps) {
    const spinnerColor: Record<SpinnerColors, string> = {
        default: 'text-white',
        primary: 'text-primary-500',
        secondary: 'text-secondary',
        variant: 'text-variant-800',
        gray: 'text-gray-700',
    };
    const classes = twMerge(props.className, spinnerColor[props.color || 'default']);
    return (
        <div className="animate-spin w-fit h-fit">
            <Icon data-testid="spinner" name="ri-loader-4-line" size={props.size} className={classes} />
        </div>
    );
}

Spinner.defaultProps = {
    color: 'default',
};

export default Spinner;
